export class ListMicrosoft365GroupsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365GroupsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
